'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';

import { GroupPost } from '@/types/billTypes';
import { BillEditor, DeclarationEditor } from './DeclarationEdit';
import { NewDeclarationEditor } from './NewDeclarationEdit';
//import { BillEditor } from './DeclarationEdit';
//import { BillDetail1 } from './BillDetail1';

interface PolicyViewWrapperProps {
    post: GroupPost;
    isEdit: boolean;
    allowedPlans?: Array<'plus' | 'pro' | 'elite'>
    resolutionBasePath: string;
    allowAllSignedIn?: boolean;
    title?: string;
}

export const BillViewWrapper: React.FC<PolicyViewWrapperProps> = ({ title, post, isEdit, allowedPlans, resolutionBasePath, allowAllSignedIn=false }) => {
    const router = useRouter();
    const [isEditing, setIsEditing] = useState(false);
    

    const handleDiscuss = (discussionId: string) => {
        router.push(`/post/${discussionId}`);
    };

    if (isEdit) {

        return <NewDeclarationEditor title={title} resolutionBasePath={resolutionBasePath} allowAllSignedIn={allowAllSignedIn} allowedPlans={allowedPlans} post={post} onBack={() => router.push(`/rule/${post.slug}`)} />;
    }

    return (
       <></>
    );
};

{/*  <BillDetail1
            post={post} 
            onBack={() => router.back()} 
            onEdit={() => router.push(`/rule/${post.slug}/edit`)}
            onDiscuss={handleDiscuss}
        /> */}